import React from "react";

export default function DowntimePage() {
  const handleRefresh = () => {
    window.location.reload();
  };

  const handleBack = () => {
    window.history.back();
  };

  const containerStyle = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #1f2937, #111827)",
    fontFamily: "Arial, sans-serif",
    color: "#ffffff",
    padding: "20px",
  };

  const cardStyle = {
    maxWidth: "520px",
    width: "100%",
    textAlign: "center",
    background: "rgba(255,255,255,0.06)",
    borderRadius: "16px",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.4)",
    backdropFilter: "blur(8px)",
  };

  const iconStyle = {
    fontSize: "60px",
    marginBottom: "20px",
  };

  const titleStyle = {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "15px",
  };

  const textStyle = {
    fontSize: "18px",
    color: "#d1d5db",
    lineHeight: "1.6",
    marginBottom: "30px",
  };

  const buttonPrimary = {
    background: "#facc15",
    border: "none",
    color: "#000",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
    marginRight: "10px",
  };

  const buttonSecondary = {
    background: "transparent",
    border: "1px solid #facc15",
    color: "#facc15",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "600",
    borderRadius: "10px",
    cursor: "pointer",
    transition: "0.3s",
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={iconStyle}>🚧</div>

        <h1 style={titleStyle}>We&apos;ll Be Back Soon</h1>

        <p style={textStyle}>
          Our website is currently under maintenance or temporarily unavailable.
          Our team is working to restore the service as quickly as possible.
        </p>

        <div>
          <button
            style={buttonPrimary}
            onMouseOver={(e) => (e.target.style.background = "#eab308")}
            onMouseOut={(e) => (e.target.style.background = "#facc15")}
            onClick={handleRefresh}
          >
            🔄 Try Again
          </button>

          <button
            style={buttonSecondary}
            onMouseOver={(e) => (e.target.style.background = "#facc15")}
            onMouseOut={(e) => (e.target.style.background = "transparent")}
            onClick={handleBack}
          >
            ⬅ Back
          </button>
        </div>

        <p style={{ marginTop: "25px", color: "#9ca3af", fontSize: "14px" }}>
          Thank you for your patience 🙏
        </p>
      </div>
    </div>
  );
}